<template>
  <div id="app-main-div" :class="[$style.app, $style.paymentPage, showHamIcon ? $style.open : '']">
    <fou-impersonate-header v-if="getImpersonateUser" />
    <fou-navigation v-if="$route.name !== 'print_contract'" />
    <side-navigation @isNavBarOpen="changeViewSize" />
    <div
      v-if="router.includes($route.name)"
      :class="[
        $route.fullPath === LOGIN || $route.fullPath === '/' ? $style.logInPage : $style.page,
        user.authenticated ? null : $style.notLoggedIn,
        showHamIcon ? $style.open : '',
        getImpersonateUser ? $style.shiftMargin : '',
        showFullView ? $style.showFullView : ''
      ]"
      @click="changeHamIconStatus(false)"
    >
      <router-view :key="$route.fullPath" />
      <fou-footer v-if="!noFooterArr.includes($route.name)" />
    </div>
    <grid-view />
    <fou-overlay />
    <fou-errors />
    <FoundryContractPopup
      v-if="showContractTerminationModal && fcpSections.length"
      :isOpen="showContractTerminationModal"
      :titleKey="fcpTitleKey"
      :titleParams="fcpTitleParams"
      :isAdmin="fcpIsAdmin"
      :sections="fcpSections"
      :learnMoreLinks="fcpLearnMoreLinks"
      @close="handleFcpClose"
      @seeChanges="handleFcpSeeChanges"
      @signAgreement="handleFcpSignAgreement"
    />
    <ReReleaseSuccessModal
      :isOpen="showReReleaseModal"
      @close="closeReReleaseModal"
      @go-to-dashboard="goToDashboard"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import FouErrors from 'components/general/fou-errors/'
import FouFooter from 'components/general/fou-footer/'
import FouNavigation from 'components/general/fou-navigation/'
import FouOverlay from 'components/overlay/fou-overlay/'
import GridView from 'components/gridview/'
import { LOGIN } from 'src/utils/constants/app-routes'
import { AGGREMENTS, HOME } from 'src/utils/constants/app-routes-name'
import SideNavigation from 'components/general/fou-side-navigation/'
import { mapGetters, mapActions } from 'vuex'
import FouImpersonateHeader from 'components/general/fou-impersonate-header/'
import FoundryContractPopup from 'components/general/foundry-contract-popup/FoundryContractPopup.vue'
import ReReleaseSuccessModal from 'components/general/re-release-success-modal/ReReleaseSuccessModal.vue'
import { adobeCjaEventEmitter } from 'modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_TYPES, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES } from 'modules/adobe-cja/constants'
export default {
  name: 'App',

  components: {
    FouNavigation,
    FouErrors,
    FouOverlay,
    GridView,
    FouFooter,
    SideNavigation,
    FouImpersonateHeader,
    FoundryContractPopup,
    ReReleaseSuccessModal
  },
  props: {
    router: {
      type: Array,
      default: () => [
        '403', '500', '503', '404', '400', '412', 'expired', 'login', 'logout', 'get_started', 'sign_up',
        'home', 'verify_email', 'dashboard', 'styleguide', 'settings', 'submissions_id', 'submissions_correct', 'submissions_details',
        'released_submissions_details', 'live_submissions_correct', 'contract', 'print_contract',
        'post_contract', 'promos', 'new_promo', 'success_promotion', 'success_pay', 'success_submission',
        'success_agreement', 'success_signup', 'success_signup_status', 'success_foundry_update', 'view_promo', 'edit_promo',
        'submissions_support_edit', 'submissions_support_review', 'foundry_records', 'application', 'application_status', 'application_preview', 'earnings_report_dashboard', 'quarterly_statements', 'bulk_import',
        'payment_accounts', 'payment_dashboard', 'payment_edit_data_manager', 'payment_new_data_manager', 'foundry_profile', 'edit_foundry', 'user_profile', 'user_permissions','424', 'payment_account_error',
        'login_page', 'BundleDashboard', 'BundleSubmissionDraft', 'BundleSuccess', 'impersonate', 'dashboard_home', 'non_ufda2', 'InventoryIngestionHub', 'InventoryIngestionCreate', 'mfp-numbers',
        'DropShip', 'UploadFlipFonts', 'terminated_contract', 'reactivate_font_families', 'quarterly-earnings-upload'
      ]
    }
  },

  data: () => ({
    errorPagesArr: ['500', '400', '403', '404', '412', '424'],
    noFooterArr: ['print_contract'],
    showFullView: localStorage.getItem('isNavBarOpen') === 'false' ? true : false
  }),

  created() {
    this.LOGIN = LOGIN
  },

  computed: {
    ...mapGetters('auth', ['user', 'getLogoutState', 'showContractTerminationModal', 'contractTerminationModalProps']),
    ...mapGetters('profile', ['showReReleaseModal']),
    ...mapGetters('sideNavigation', ['showHamIcon']),
    getImpersonateUser() {
      if (this.user.impersonate) {
        return this.user.impersonate
      }
      const fetchFSValue = JSON.parse(window.localStorage.getItem('FS-Impersonate'))
      if (fetchFSValue && !this.getLogoutState) {
        return true
      }
      return false
    },
    fcpTitleKey() {
      return this.contractTerminationModalProps?.titleKey || 'foundry_contract_popup.title_terminated_single'
    },
    fcpTitleParams() {
      return this.contractTerminationModalProps?.titleParams || {}
    },
    fcpIsAdmin() {
      return this.contractTerminationModalProps?.isAdmin || false
    },
    fcpSections() {
      return this.contractTerminationModalProps?.sections || []
    },
    fcpLearnMoreLinks() {
      return this.contractTerminationModalProps?.learnMoreLinks || {}
    }
  },
  methods: {
    ...mapActions('sideNavigation', ['changeHamIconStatus']),
    changeViewSize(e) {
      this.showFullView = !e;
    },
    closeFcpModal() {
      this.$store.commit('auth/setContractTerminationModal', { show: false, props: null })
    },
    handleFcpClose() {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.FOUNDRY_PARTNER_AGREEMENT_ENDING_SOON,
          linkSection: LINK_SECTION.FOUNDRY_PARTNER_AGREEMENT_ENDING_SOON,
          linkName: LINK_NAMES.CLOSE,
          linkType: LINK_TYPES.BUTTON
        }
      })
      this.closeFcpModal()
    },
    handleFcpSeeChanges() {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.FOUNDRY_PARTNER_AGREEMENT_ENDING_SOON,
          linkSection: LINK_SECTION.FOUNDRY_PARTNER_AGREEMENT_ENDING_SOON,
          linkName: LINK_NAMES.SEE_WHATS_CHANGED,
          linkType: LINK_TYPES.BUTTON
        }
      })
      console.log('[ContractTermination] seeChanges triggered')
      this.closeFcpModal()
    },
    handleFcpSignAgreement() {
      const foundryNames = this.fcpSections.flatMap(s => (s.foundries || []).map(f => f.name)).filter(Boolean)
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.FOUNDRY_PARTNER_AGREEMENT_ENDING_SOON,
          linkSection: LINK_SECTION.FOUNDRY_PARTNER_AGREEMENT_ENDING_SOON,
          linkName: LINK_NAMES.SIGN_LATEST_AGREEMENT,
          linkType: LINK_TYPES.BUTTON
        },
        font: foundryNames.map(name => ({ fontFoundary: name }))
      })
      this.closeFcpModal()
      this.$router.push({ name: AGGREMENTS })
    },
    closeReReleaseModal () {
      this.$store.commit('profile/setReReleaseModal', false)
    },
    goToDashboard () {
      this.closeReReleaseModal()
      if (this.$route.name !== HOME) {
        this.$router.push({ name: HOME })
      }
    }
  },

  updated() {
    // Check for changes in the specific key in local storage
    const newValue = JSON.parse(localStorage.getItem('roles'));
    if (window && newValue && window.zE) {
      if (newValue.includes('foundrySupport') || newValue.includes('FS-Impersonate') || newValue.includes('bulkIngestionUser')) {
        window.zE('webWidget', 'hide')
      }
      else {
        window.zE('webWidget', 'show')
      }
    }
  },
}
</script>

<style lang="scss" module>
.app {
  height: 100%;
}

.page {
  width: calc(100% - 303px);
  transition: all 0.5s;
  min-height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 56px;
  margin-left: auto;
  @media (max-width: 1279px) {
    width: 100%;
  }
  &.open {
    position: relative;
    &:after {
      position: fixed;
      opacity: 0.5;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      content: '';
      z-index: 4;
      @media screen and (max-width: 1279px) {
        background: #1e242c;
      }
    }
  }
  &.shiftMargin {
    margin-top: 103px;
  }
}

.showFullView {
  width: calc(100% - 32px);
  transition: all 0.5s;
  @media screen and (max-width: 1279px) {
    width: 100%;
  }
}

.paymentPage {
  display: flex;
  flex-direction: row;
  height: 100%;
  left: 0px;
  top: 0px;
  width: 100%;
  // overflow-y: auto;
  &.open {
    overflow-y: auto;
  }
}

.logInPage {
  align-items: center;
  display: grid;
  grid-template-rows: 1fr;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.notLoggedIn {
  width: 100%;
}
</style>
